import { useEffect } from "react";

const SITE = "BABIMIX";

export default function useSEO({ title, description, image, type = "website", keywords, jsonLd, noindex } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE}` : `${SITE} — Sorties, événements & LIVE à Abidjan`;
    document.title = fullTitle;

    const origin = window.location.origin;
    const absImage = image
      ? (image.startsWith("http") ? image : origin + (image.startsWith("/") ? "" : "/") + image)
      : origin + "/favicon-512.png";

    const setMeta = (attr, key, val) => {
      if (val == null || val === "") return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute("content", val);
    };

    setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", absImage);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", window.location.href);
    setMeta("property", "og:site_name", SITE);
    setMeta("property", "og:locale", "fr_CI");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", absImage);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.setAttribute("rel", "canonical"); document.head.appendChild(canonical); }
    canonical.setAttribute("href", window.location.href.split("?")[0]);

    let robots = document.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) { robots = document.createElement("meta"); robots.setAttribute("name", "robots"); document.head.appendChild(robots); }
      robots.setAttribute("content", "noindex, nofollow");
    } else if (robots) {
      robots.remove();
    }

    let script = document.getElementById("seo-jsonld");
    if (jsonLd) {
      if (!script) { script = document.createElement("script"); script.type = "application/ld+json"; script.id = "seo-jsonld"; document.head.appendChild(script); }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, image, type, keywords, noindex, JSON.stringify(jsonLd)]);
}
